import React from 'react';
import { Link } from 'react-router-dom';
import './courses.css';

const ShortTerm = () => {
    const topics = [
        "Synthesis Inputs", "Net Delay", "Timing paths", "Floorplan",
        "CTS", "Routing", "Cross talk", "Tool Session"
    ];

    return (
        <div className="course-detail-page">
            <section className="detail-hero" data-aos="fade-up">
                <Link to="/courses/physical-design" className="back-link">&larr; Back to Physical Design</Link>
                <h1>11 Days <span>Crash Course</span></h1>
                <p>Speed up your VLSI skills with our intensive short-term program.</p>
            </section>

            <section className="detail-content">
                <div className="detail-grid">
                    <div className="curriculum glass" data-aos="fade-right">
                        <h3>What you will learn</h3>
                        <ul>
                            {topics.map((topic, index) => (
                                <li key={index}><span className="bullet"></span> {topic}</li>
                            ))}
                        </ul>
                        <div className="timing-info glass">
                            <h4>Timing</h4>
                            <p>10:00 AM – 11:30 AM</p>
                        </div>
                    </div>
                    <div className="sticky-info" data-aos="fade-left">
                        <div className="info-box glass">
                            <h4>Course Details</h4>
                            <div className="info-row">
                                <span>Duration:</span>
                                <span>11 Days</span>
                            </div>
                            <div className="info-row">
                                <span>Fee:</span>
                                <span>₹6,000 + GST</span>
                            </div>
                            <Link to="/contact" className="btn btn-gold full-width">Enroll Now</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ShortTerm;